import React, {useState, useEffect, useRef} from "react";
import * as Styled from './style.js';
import logo from '../../assets/images/sp-logo-white.png'
import { Button, Form, Input, Modal, Spin, Select } from 'antd';
import { postData } from '../../config/api-connect';
import Spinner from '../../components/spinner'

const errorModal = (message) => {
  Modal.error({
    title: message,
  });
};

export default function Login() {

  const [number, setNumber] = useState('');
  const [otp, setOTP] = useState('');
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryCode,setCountryCode] = useState('91')
  const [retryAfter, setRetryAfter] = useState(0);

  const otpRef = useRef(null)
  const retryTimerRef = useRef(null)

  useEffect(() => () => clearInterval(retryTimerRef.current), []);

  const startRetryCountdown = (seconds) => {
    clearInterval(retryTimerRef.current);
    setRetryAfter(seconds);
    retryTimerRef.current = setInterval(() => {
      setRetryAfter((prev) => {
        if (prev <= 1) {
          clearInterval(retryTimerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(()=> {
    if(otpRef && otpRef.current) {
      otpRef.current.focus();
    }
  },[validate])

  const onNumberChange = (e) => {
    setNumber( e.target.value);
  };

  const onOTPChange = (e) => {
    setOTP( e.target.value )
  }

  const handleSubmitNumber = async () => {
  try {
    setLoading(true);
    const response = await postData('/auth/verify_mobile_start', {
      mobile_no: number,
      name: "hds",
      country_code: countryCode
    });
    setLoading(false);
    if (response.success === false || response.authentication === false) {
      errorModal(response.message || 'Something went wrong. Please try again.');
      return;
    }
    setValidate(response.authentication);
  } catch (error) {
    setLoading(false);
    if (error.status === 429 && error.retryAfter) {
      // Ticking countdown below the button instead of a static modal --
      // the wait duration is only meaningful while it's live.
      startRetryCountdown(error.retryAfter);
    } else {
      errorModal(error.message);
    }
  }
}

  const handleLoginUser = () => {
    setLoading(true)
    postData('/auth/verify_mobile', {'mobile_no':number,'otp':otp})
    .then(response =>{
      setLoading(false)
      if (response.success === false) {
        errorModal(response.message || 'Something went wrong. Please try again.');
        return;
      }
      localStorage.setItem('access_id', response.user.id)
      localStorage.setItem('user_role', response.user.role)
      localStorage.setItem('user_name', response.user.name)
      window.location.reload()
    })
    .catch(error => {
      setLoading(false)
      if (error.status === 429 && error.retryAfter) {
        startRetryCountdown(error.retryAfter);
      } else {
        errorModal(error.message);
      }
    });
  }

  const handleChange = (value) => {
    setCountryCode(value)
  };

  return(
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>
        <Styled.NavBarContainer className="col-md-12">


              <Styled.Header>
                <img src={logo} alt="Sporthood Finance"/>
              </Styled.Header>
              <Form
                name="basic"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 12,
                }}
                initialValues={{
                  remember: true,
                }}
                // onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{padding: '20px 20px 0 20px'}}
              > 
                <Form.Item
                  label="Mobile No"
                  name="mobile_no"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your mobile number!',
                    },
                  ]}
                >
                  <div style={{display:'flex',gap:'5px'}}>
                    <Select
                      defaultValue="+91"
                      value={countryCode}
                      style={{ width: 90 }}
                      onChange={handleChange}
                      options={[
                        {
                          value: '91',
                          label: '+91',
                        },
                        {
                          value: '971',
                          label: '+971',
                        },
                        {
                          value: '974',
                          label: '+974',
                        },
                        {
                          value: '965',
                          label: '+965',
                        },
                      ]}
                    />
                    <Input value = {number} onChange={onNumberChange} allowClear/>
                  </div>
                </Form.Item>
                {
                  validate &&
                  <>
                    <Styled.OTPhelper> 6 digit OTP ( One Time Password ) is sent to {number} </Styled.OTPhelper>

                    <Form.Item
                      label="OTP"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter 6 digit otp!',
                        },
                      ]}
                    >
                      <Input ref={otpRef} value = {otp} onChange={onOTPChange} />
                    </Form.Item>
                  </>
                }

                {
                  retryAfter > 0 &&
                  <Styled.OTPhelper>
                    Too many attempts. Please try again in {retryAfter}s.
                  </Styled.OTPhelper>
                }

                <Form.Item style={{display: 'flex', justifyContent: 'center',marginBottom:'20px'}}>
                  {
                    !validate ?
                      <Button type="primary" htmlType="submit" disabled={retryAfter > 0} onClick={()=>handleSubmitNumber()}> {retryAfter > 0 ? `Try again in ${retryAfter}s` : 'Get OTP'} </Button>
                    :
                      <Button type="primary" htmlType="submit" disabled={retryAfter > 0} onClick={()=>handleLoginUser()}> {retryAfter > 0 ? `Try again in ${retryAfter}s` : 'Login'} </Button>
                  }
                </Form.Item>
              </Form>

        </Styled.NavBarContainer>
      </Styled.MainContainer>
    </Spin>
)
}
